import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";

@Component({
    selector: 'app-component-error-e204',
    templateUrl: './error-e204.component.html',
    styleUrls: ['./error-e204.component.css']
})

export class ErrorE204Component implements OnInit {
    isMobile = window.innerWidth < 1000 ? true : false;

    constructor(private router : Router, private titleService : Title) { 
        this.titleService.setTitle("Lỗi 204 - No Content");
    }
    ngOnInit() {}

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }

    
}